import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import ErrorPage from '@/views/Error.vue'
import store from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },

  // Manager dashboard — restricted to all_permissions. The MyTeamController
  // also enforces this server-side via can('all_permissions').
  {
    path: '/my-team',
    name: 'MyTeam',
    component: () => import(/* webpackChunkName: "my-team" */ '@/components/my-team/MyTeam.vue'),
    meta: { permission: 'all_permissions' },
  },


  // user access //
  {
    path: '/user-access',
    name: 'UserAccess',
    component: () => import(/* webpackChunkName: "useraccess" */ '@/components/user-access/UserAccess.vue'),
    meta: { permission: 'hrms' },
    // meta: {permission: 'all_permissions'},
  },

  // holidays
  {
    path: '/public-holidays',
    name: 'publicHolidays',
    component: () => import(/* webpackChunkName: "publicHolidays" */ '@/components/public-holidays/index.vue'),
    meta: { permission: 'hrms' },
    // meta: {permission: 'all_permissions'},
  },

  // job-titles
  {
    path: '/job-titles',
    name: 'JobTitles',
    component: () => import(/* webpackChunkName: "jobtitle" */ '@/components/positions/JobTitlesList.vue'),
    meta: { permission: 'hrms' },
    // meta: {permission: 'all_permissions'},
  },

  // positions
  {
    path: '/positions',
    name: 'Positions',
    component: () => import(/* webpackChunkName: "positions" */ '@/components/positions/PositionsList.vue'),
    meta: { permission: 'hrms' },
  },

  // staff position assignments
  {
    path: '/staff-position-assignments',
    name: 'StaffPositionAssignments',
    component: () => import(/* webpackChunkName: "staff-assignments" */ '@/components/positions/StaffPositionAssignmentsList.vue'),
    meta: { permission: 'hrms' },
  },


  // {
  //   path: '/entries',
  //   name: 'EntryList',
  //   component: () => import(/* webpackChunkName: "entry-list" */ '@/components/entries/EntryList.vue'),
  // },

  {
    path: '/payroll-report',
    name: 'PayrollReport',
    component: () => import(/* webpackChunkName: "PayrollReport" */ '@/components/payroll-report/StaffPayrollView.vue'),
  },

  {
    path: '/:section_id/section-dashboard/:unit_id?',
    name: 'SectionDashboard',
    component: () => import(/* webpackChunkName: "useraccess" */ '@/components/section-dashboard/SectionDashboard.vue'),
    meta: { permission: 'all_permissions' },
  },

  {
    path: '/allowance-types',
    name: 'AllowanceTypes',
    component: () => import(/* webpackChunkName: "AllowanceTypes" */ '@/components/staff_finances/AllowanceTypes.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/leave-types',
    name: 'LeaveTypes',
    component: () => import(/* webpackChunkName: "leave-types" */ '@/components/leave-types/LeaveTypes.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/rainy-days',
    name: 'RainyDays',
    component: () => import(/* webpackChunkName: "rainy-days" */ '@/components/rainy-days/RainyDays.vue'),
    meta: { permission: 'hrms' },
  },


  {
    path: '/sign-documents',
    name: 'DocumentsToSign',
    component: () => import(/* webpackChunkName: "documents-to-sign" */ '@/components/sign_documents/SignDocuments.vue'),
  },

  {
    path: '/attendance',
    name: 'Attendance',
    component: () => import(/* webpackChunkName: "attendance" */ '@/components/Attendance.vue'),
  },

  {
    path: '/manage-staff-attendance',
    name: 'ManageStaffAttendace',
    component: () => import(/* webpackChunkName: "manage-attendance" */ '@/components/attendance/ManageStaffAttendance.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/phonebook',
    name: 'Phonebook',
    component: () => import(/* webpackChunkName: "phonebook-new" */ '@/components/phonebook/Phonebook.vue'),
  },

  {
    path: '/phonebook-new',
    name: 'PhoneBookNew',
    component: () => import(/* webpackChunkName: "phonebook-new-new" */ '@/components/phonebook/NewPhoneBook.vue'),
  },

  // {
  //   path: '/3cx',
  //   name: '3CXPhonebook',
  //   component: () => import(/* webpackChunkName: "staffs" */ '@/components/phonebook/3CXPhonebook.vue'),
  //   meta: { permission: 'hrms' },
  // },

  {
    path: '/card-logs',
    name: 'CardLogs',
    component: () => import(/* webpackChunkName: "card-logs" */ '@/components/CardLogs.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/staffs',
    name: 'Staffs',
    component: () => import(/* webpackChunkName: "staffs" */ '@/components/staffs/AllStaffs.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/recruitment/applications/:uuid',
    name: 'JobApplications',
    component: () => import(/* webpackChunkName: "applications" */ '@/components/recruitment/Applications.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/recruitment',
    name: 'Recruitment',
    meta: { permission: 'hrms' },
    // component: () => import(/* webpackChunkName: "jobs" */ '@/components/recruitment/AllJobs.vue'),
    component: () => import(/* webpackChunkName: "jobs" */ '@/components/recruitment/Recruitment.vue'),
    children: [
      {
        path: 'jobs',
        name: 'Jobs',
        component: () => import(/* webpackChunkName: "jobs" */ '@/components/recruitment/AllJobs.vue'),
      },
      {
        path: 'applications',
        name: 'Applications',
        component: () => import(/* webpackChunkName: "jobs" */ '@/components/recruitment/AllJobs.vue'),
      },
      {
        path: 'my-interviews',
        name: 'MyInterviews',
        component: () => import(/* webpackChunkName: "MyInterviews" */ '@/components/recruitment/MyInterviews.vue'),
      },
      {
        path: 'my-interviews/:session_id',
        name: 'MyInterviewSessionApplicants',
        component: () => import(/* webpackChunkName: "MyInterviews" */ '@/components/recruitment/MyInterviewSessionApplicants.vue'),
      },
      {
        path: 'classifications',
        name: 'Classifications',
        component: () => import(/* webpackChunkName: "classifications" */ '@/components/recruitment/Classifications.vue'),
      },
    ]
  },

  // booking system routes
  {
    path: '/events',
    name: 'Bookings',
    component: () => import(/* webpackChunkName: "events-layout" */ '@/components/Bookings/Bookings.vue'),
    children: [
      {
        path: 'all',
        name: 'AllBookings',
        // component: () => import(/* webpackChunkName: "all-events" */ '@/components/Bookings/AllBookings.vue'),
        component: () => import(/* webpackChunkName: "my-calender" */ '@/components/Bookings/MyCalender.vue'),
      },
      {
        path: 'my-callender',
        name: 'MyCalender',
        component: () => import(/* webpackChunkName: "my-calender" */ '@/components/Bookings/MyCalender.vue'),

      },
      {
        path: 'my',
        name: 'MyBookings',
        component: () => import(/* webpackChunkName: "my-events" */ '@/components/Bookings/MyBookings.vue'),

      },
      {
        path: 'rooms',
        name: 'Rooms',
        component: () => import(/* webpackChunkName: "rooms" */ '@/components/Bookings/Rooms.vue'),

      },
      {
        path: 'out-going',
        name: 'out-going-events',
        component: () => import(/* webpackChunkName: "out-going-events" */ '@/components/Bookings/OutGoingEvents.vue'),

      },
    ]
  },

  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '@/components/profile/Profile.vue'),
  },
  {
    path: '/profile/sms-notifications',
    name: 'SmsNotifications',
    component: () => import(/* webpackChunkName: "profile-sms" */ '@/components/profile/SmsNotifications.vue'),
  },

  {
    path: '/document-templates',
    name: 'DocumentTemplates',
    component: () => import(/* webpackChunkName: "templates" */ '@/components/DocumentTemplate/TemplateList.vue'),
    meta: {
      permission: 'hrms'
    }
  },

  // System documents (the dashboard "Documents" block) — list + URL-addressable
  // standalone pages. ':id' must be declared after the literal list route.
  {
    path: '/documents',
    name: 'Documents',
    component: () => import(/* webpackChunkName: "documents" */ '@/components/util/DocumentsPage.vue'),
  },
  {
    path: '/documents/:id(\\d+)',
    name: 'DocumentView',
    component: () => import(/* webpackChunkName: "documents" */ '@/components/util/DocumentView.vue'),
  },

  // FAQ lives inside the Knowledge Base (Documents) page.
  // Keep /faq as a convenience redirect for old links/bookmarks.
  {
    path: '/faq',
    redirect: to => ({ name: 'Documents', query: { ...to.query } }),
  },



  // Overtime functionality routes
  {
    path: '/overtime/apply',
    name: 'OTApplyNew',
    component: () => import(/* webpackChunkName: "otApplyNew" */ '@/components/overtime/OTApply.vue'),
  },
  // {
  //   path: '/overtime/apply',
  //   name: 'OTApply',
  //   component: () => import(/* webpackChunkName: "overtimeApply" */ '@/components/overtime/OvertimeRequests.vue'),
  //   // component: () => import(/* webpackChunkName: "overtimeContainer" */ '@/components/Layout.vue'),
  //   // children: [
  //   //   {
  //   //     path: 'apply',
  //   //     name: 'OTApply',
  //   //     component: () => import(/* webpackChunkName: "overtimeApply" */ '@/components/overtime/OvertimeRequests.vue'),
  //   //     meta: {permission: 'all_permissions'},
  //   //   },
  //   // ],
  // },

  {
    path: '/:sectionID/ot_approval/:unitID?',
    name: 'OTApproval',
    component: () => import(/* webpackChunkName: "overtimeApproval" */ '@/components/overtime/OvertimeApproval.vue'),
    // meta: {permission: 'all_permissions'}
  },

  {
    path: '/ot_approval_new',
    name: 'OTApprovalNew',
    component: () => import(/* webpackChunkName: "overtimeApprovalNew" */ '@/components/overtime/NewOvertimeApprovalView.vue'),
    // meta: {permission: 'all_permissions'}
  },

  {
    path: '/overtime/section/:section/unit/:unit',
    name: 'OTApprovalWithUnit',
    component: () => import(/* webpackChunkName: "overtimeApproval" */ '@/components/overtime/OvertimeApproval.vue'),
    meta: { permission: 'all_permissions' }
  },

  // attendance slip requests

  {
    path: '/po-request',
    name: 'PORequests',
    component: () => import(/* webpackChunkName: "po-request" */ '@/components/po-request/PORequests.vue'),
  },
  {
    path: '/:section/personal_out_requests/:unit?',
    name: 'ApprovePORequest',
    component: () => import(/* webpackChunkName: "po-request" */ '@/components/po-request/PORequests.vue'),
  },
  {
    path: '/approved-po-requests',
    name: 'ApprovedPORequest',
    component: () => import(/* webpackChunkName: "po-request" */ '@/components/po-request/PORequests.vue'),
    meta: { permission: 'hrms' }
  },

  // attendance requests
  {
    path: '/attendance-slips',
    name: 'attendance-requests',
    component: () => import(/* webpackChunkName: "overtimeApply" */ '@/components/attendance/AttendanceRequests.vue'),
  },
  {
    path: '/attendance-slip/my-requests',
    name: 'slip-my-requests',
    component: () => import(/* webpackChunkName: "overtimeApply" */ '@/components/attendance/RequestsList.vue'),
    meta: { type: 'staff' },
  },

  {
    path: '/attendance-slip/hr-list',
    name: 'slip-hr-requests',
    component: () => import(/* webpackChunkName: "leaveDocument" */ '@/components/attendance/RequestsList.vue'),
    meta: { permission: 'hrms', type: 'hrms' },
  },

  {
    path: '/attendance-slip/approval-list',
    name: 'slip-hr-requests',
    component: () => import(/* webpackChunkName: "leaveDocument" */ '@/components/attendance/RequestsList.vue'),
    meta: { type: 'approval' },
  },



  // leaves
  {
    path: '/leaves',
    name: 'Leaves',
    component: () => import(/* webpackChunkName: "layout" */ '@/components/Layout.vue'),
    // meta: {permission: 'all_permissions'},
    children: [
      {
        path: 'requests',
        name: 'LeaveRequests',
        component: () => import(/* webpackChunkName: "leaveRequests" */ '@/components/leaves/LeaveRequests.vue'),
      },
      {
        path: 'approved',
        name: 'ApprovedLeaveRequests',
        component: () => import(/* webpackChunkName: "approvedLeaveRequests" */ '@/components/leaves/ApprovedLeaveRequests.vue'),
      },
      {
        path: 'grant-my-approval',
        name: 'GrantMyApproval',
        component: () => import(/* webpackChunkName: "grantMyApproval" */ '@/components/leaves/LeaveRequestApprovalList.vue'),
      },
    ],
  },

  {
    path: '/annual-carryforward',
    name: 'AnnualCarryforward',
    component: () => import(/* webpackChunkName: "AnnualCarryforward" */ '@/components/annual-carryforward/AnnualCarryForwardRequets.vue'),
    // meta: { permission: 'hrms' },
  },

  {
    path: '/attendance-correction',
    name: 'AttendanceCorrection',
    component: () => import(/* webpackChunkName: "attendanceCorrection" */ '@/components/attendance/AttendanceCorrection.vue'),
    props: { mode: 'personal' },
  },

  {
    path: '/attendance-correction-approval',
    name: 'AttendanceCorrectionApproval',
    component: () => import(/* webpackChunkName: "attendanceCorrection" */ '@/components/attendance/AttendanceCorrection.vue'),
    props: { mode: 'approval' },
    meta: { permission: ['hrms', 'pg_approval'] },
  },

  {
    path: '/attendance-debug',
    name: 'AttendanceDebug',
    component: () => import(/* webpackChunkName: "attendanceDebug" */ '@/components/attendance/AttendanceDebug.vue'),
    // meta: { permission: 'all_permissions' },
    meta: { permission: 'hrms' },
  },

  {
    path: '/staff-attendance/dashboard',
    name: 'StaffAttendanceDashboard',
    component: () => import(/* webpackChunkName: "staffAttendanceDashboard" */ '@/components/attendance/StaffAttendanceDashboard.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/staff-attendance/filter',
    name: 'StaffAttendanceFilter',
    component: () => import(/* webpackChunkName: "staffAttendanceFilter" */ '@/components/attendance/StaffAttendanceFilter.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/overtime-debug',
    name: 'OvertimeDebug',
    component: () => import(/* webpackChunkName: "overtimeDebug" */ '@/components/overtime/OvertimeDebug.vue'),
    meta: { permission: 'all_permissions' },
  },

  {
    path: '/overtime-cap-debug',
    name: 'OvertimeCapDebug',
    component: () => import(/* webpackChunkName: "overtimeCapDebug" */ '@/components/overtime/OvertimeCapDebug.vue'),
    meta: { permission: 'all_permissions' },
  },

  {
    path: '/leave-documents',
    name: 'LeaveDocuments',
    component: () => import(/* webpackChunkName: "leaveDocument" */ '@/components/leaves/LeaveDocumentApprove.vue'),
    meta: { permission: 'hrms' },
  },
  {
    path: '/my-leave-documents',
    name: 'MyLeaveDocuments',
    component: () => import(/* webpackChunkName: "leaveDocument" */ '@/components/leaves/LeaveDocumentApprove.vue'),
  },

  {
    path: '/leave-adjustment-requests',
    name: 'LeaveAdjustmentRequests',
    component: () => import(/* webpackChunkName: "LeaveAdjustmentRequests" */ '@/components/leaves/LeaveAdjustmentRequests.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/mail-groups',
    name: 'MailGroups',
    component: () => import(/* webpackChunkName: "mailgroups" */ '@/components/mail-groups/AllMailGroups.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/special-leaves',
    name: 'SpecialLeaves',
    component: () => import(/* webpackChunkName: "leaveDocument" */ '@/components/special-leaves/SpecialLeavesView.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/:section/leave_approval/:unit?',
    name: 'ApproveLeaveRequest',
    // meta: {permission: 'all_permissions'},
    component: () => import(/* webpackChunkName: "leaveRequestApprovalList" */ '@/components/leaves/LeaveRequestApprovalList.vue'),
  },

  {
    path: '/:section/wfh_approval/:unit?',
    name: 'WorkFromHomeApproval',
    // meta: {permission: 'all_permissions'},
    component: () => import(/* webpackChunkName: "workFromHomeApproval" */ '@/components/leaves/LeaveRequestApprovalList.vue'),
  },


  // form listings
  {
    path: '/:sectionID/form-listing/:unitID?',
    name: 'HandOverFormList',
    // meta: {permission: 'all_permissions'},
    component: () => import(/* webpackChunkName: "workFromHomeApproval" */ '@/components/formStatusList/FormList.vue'),
  },
  {
    path: '/unit/:unitID/form-listing',
    name: 'unitFormList',
    component: () => import(/* webpackChunkName: "workFromHomeApproval" */ '@/components/formStatusList/FormList.vue'),
  },

  // new leave approval view
  {
    path: '/leave_approval_new',
    name: 'leaveApprovalNew',
    component: () => import(/* webpackChunkName: "leaveApprovalNew" */ '@/components/formStatusList/NewLeaveApprovalList.vue'),
  },


  {
    path: '/staff_forms_approval',
    name: 'StaffFormsApproval',
    component: () => import(/* webpackChunkName: "StaffFormsApproval" */ '@/components/staff-forms/StaffFormsList.vue'),
  },




  {
    path: '/:sectionID/hand_over_approval/:unitID?',
    name: 'HandOverFormApproval',
    // meta: {permission: 'all_permissions'},
    component: () => import(/* webpackChunkName: "workFromHomeApproval" */ '@/components/formStatusList/FormList.vue'),
  },

  // report
  {
    path: '/reports',
    name: 'ReportView',
    // meta: {permission: 'all_permissions'},
    component: () => import(/* webpackChunkName: "reportView" */ '@/components/report/ReportsView.vue')
  },

  // memo
  {
    path: '/manage-memos',
    name: 'manage-memos',
    component: () => import(/* webpackChunkName: "memos" */ '@/components/memos/Memos.vue'),
    meta: { permission: 'memo' },
  },
  {
    path: '/memos',
    name: 'memos',
    component: () => import(/* webpackChunkName: "memos" */ '@/components/memos/Memos.vue'),
  },

  // tasks
  //
  // Permission policy (2026-05-16): the read surfaces (all / chart / todos /
  // workboard) are open to any authenticated staff — the backend already
  // filters every list to the rows the caller can see (TaskController::getTasks
  // visibility filter). Same pattern as /overtime/apply, which has no
  // route-level gate either. Only the admin-y pages stay restricted.
  {
    path: '/tasks',
    name: 'Tasks',
    component: () => import(/* webpackChunkName: "layout" */ '@/components/Layout.vue'),
    children: [
      {
        path: 'all',
        name: 'AllTasks',
        component: () => import(/* webpackChunkName: "list" */ '@/components/tasks/Tasks.vue'),
      },
      {
        path: 'chart',
        name: 'Chart',
        component: () => import(/* webpackChunkName: "chart" */ '@/components/tasks/Chart.vue'),
      },
      // Productivity dashboard (assignee + reviewer metrics) — still gated to
      // assigned_task since not everyone needs the analytics surface.
      {
        path: 'metrics',
        name: 'TaskMetrics',
        component: () => import(/* webpackChunkName: "task-metrics" */ '@/components/tasks/TaskMetrics.vue'),
        meta: { permission: 'assigned_task' },
      },
      // Module admin — hrms-only writes.
      {
        path: 'modules',
        name: 'TaskModulesAdmin',
        component: () => import(/* webpackChunkName: "task-modules-admin" */ '@/components/tasks/TaskModulesAdmin.vue'),
        meta: { permission: 'hrms' },
      },
      // Tabular cross-task todos view (filterable). Sits alongside the cards.
      {
        path: 'todos',
        name: 'TodosTable',
        component: () => import(/* webpackChunkName: "todos-table" */ '@/components/tasks/TodosTable.vue'),
      },
      // URL-addressable task pages — replace the heavy in-page modal.
      // Path order matters: literal segments ('todos', 'metrics', 'modules',
      // 'new') must be declared before ':id' so they aren't swallowed by the
      // dynamic route.
      {
        path: 'new',
        name: 'TaskNew',
        component: () => import(/* webpackChunkName: "task-detail" */ '@/components/tasks/TaskDetail.vue'),
      },
      // Refactor 2026-05-16: /tasks/:id is the only task view. Everything that
      // used to live at /tasks/:id/manage is now inline on the workboard.
      {
        path: ':id(\\d+)',
        name: 'TaskDetail',
        component: () => import(/* webpackChunkName: "task-workboard" */ '@/components/tasks/TaskWorkboard.vue'),
      },
    ],
  },

  // job details -- positions, classifications
  {
    path: '/job-classifications',
    name: 'JobDetails',
    meta: { permission: 'hrms' },
    component: () => import(/* webpackChunkName: "layout" */ '@/components/Layout.vue'),
    children: [
      {
        path: 'positions',
        name: 'AllPositions',
        component: () => import(/* webpackChunkName: "list" */ '@/components/job-classifications/Positions.vue'),
        meta: { permission: 'hrms' },
      },
    ],
  },

  // payroll
  {
    path: '/payroll',
    name: 'payroll',
    meta: { permission: 'hrms' },
    component: () => import(/* webpackChunkName: "layout" */ '@/components/Layout.vue'),
    children: [
      {
        path: 'config',
        name: 'payroll-config',
        component: () => import(/* webpackChunkName: "payroll" */ '@/views/PayrollConfig.vue'),
        meta: { permission: 'hrms' },
      },
      {
        path: 'salary',
        name: 'payroll-salary',
        component: () => import(/* webpackChunkName: "payroll" */ '@/views/PayrollSalary.vue'),
        meta: { permission: 'hrms' },
      }
    ]
  },

  // budget salary additions
  {
    path: '/budget/salary-additions',
    name: 'SalaryAdditionsBudget',
    meta: { permission: 'budget' },
    component: () => import(/* webpackChunkName: "payroll" */ '@/components/salary-additions/SalaryAdditionsView.vue'),
  },


  // hr salary addition route
  {
    path: '/payroll/salary-additions',
    name: 'SalaryAdditionsPayroll',
    meta: { permission: 'hrms' },
    component: () => import(/* webpackChunkName: "payroll" */ '@/components/salary-additions/SalaryAdditionsView.vue'),
  },


  // Four day work week
  {
    path: '/weekly-wfh',
    name: 'weekly-wfh',
    meta: { permission: 'all_permissions' },
    component: () => import(/* webpackChunkName: "work-week" */ '@/views/WeeklyWfh.vue')
  },


  {
    path: "/office-assets",
    component: () => import(/* webpackChunkName: "office-assets" */ '@/components/Layout.vue'),
    children: [
      // assets list
      {
        path: "list",
        name: "Assets",
        component: () => import(/* webpackChunkName: "AssetsList" */ '@/components/office-assets/AssetsList.vue'),
      },

      {
        path: "dashboard",
        name: "AssetsDashboard",
        component: () => import(/* webpackChunkName: "AssetsDashboard" */ '@/components/office-assets/Dashboard.vue'),
      },

      {
        path: "workstations",
        name: "Workstations",
        component: () => import(/* webpackChunkName: "Workstations" */ '@/components/office-assets/Workstations.vue'),
      },

      // asset move requests
      {
        path: "move-requests",
        name: "AssetsMoveRequests",
        component: () => import(/* webpackChunkName: "AssetsMoveRequests" */ '@/components/office-assets/AssetsMoveRequests.vue'),
      },
      {
        path: "move-requests-approval",
        name: "AssetsMoveRequestsApproval",
        component: () => import(/* webpackChunkName: "AssetsMoveRequestsApproval" */ '@/components/office-assets/AssetsMoveRequests.vue'),
      },

      // normal staff request for assets
      {
        path: "staff-request-for-inventory",
        name: "StaffRequestForInventory",
        component: () => import(/* webpackChunkName: "RequestForAssets" */ '@/components/office-assets/RequestForAssets.vue'),
      },
      // IT Inventory requests
      {
        path: "it-inventory-requests",
        name: "ITInventoryRequests",
        component: () => import(/* webpackChunkName: "RequestForAssets" */ '@/components/office-assets/RequestForAssets.vue'),
      },
    ]
  },

  // normal staff view items assigned to workstation
  {
    path: "/inv/:station_id",
    name: "WorkstationItems",
    component: () => import(/* webpackChunkName: "WorkstationItems" */ '@/components/office-assets/WorkstationItems.vue'),
  },
  {
    path: "/inventory/workstations/:station_id/details",
    name: "WorkstationItems",
    component: () => import(/* webpackChunkName: "WorkstationItems" */ '@/components/office-assets/WorkstationItems.vue'),
  },


  {
    path: '/stock',
    component: () => import(/* webpackChunkName: "overtimeContainer" */ '@/components/Layout.vue'),
    children: [
      {
        path: 'items',
        name: 'StockList',
        component: () => import(/* webpackChunkName: "stock" */ '@/components/stock/StockList.vue'),
      },
      {
        path: 'outward',
        name: 'StockOutward',
        component: () => import(/* webpackChunkName: "StockOutward" */ '@/components/stock/StockOutward.vue'),
      },
      {
        path: 'outward-approval/:section/:unit?',
        name: 'StockOutwardApproval',
        component: () => import(/* webpackChunkName: "StockOutwardApproval" */ '@/components/stock/StockOutwardApproval.vue'),
      },
      {
        path: 'outward-issue',
        name: 'StockOutwardIssue',
        component: () => import(/* webpackChunkName: "StockOutwardIssue" */ '@/components/stock/StockOutwardIssue.vue'),
      },
      // {
      //   path: 'inward',
      //   name: 'StockInward',
      //   component: () => import(/* webpackChunkName: "StockInward" */ '@/components/stock/StockInward.vue'),
      // },
      {
        path: 'inward',
        name: 'StockInward',
        component: () => import(/* webpackChunkName: "StockInward" */ '@/components/stock/PurchaseRequests.vue'),
      },
      {
        path: 'inward-approval/:section/:unit?',
        name: 'StockInwardApproval',
        component: () => import(/* webpackChunkName: "StockInwardApproval" */ '@/components/stock/PurchaseRequestsApproval.vue'),
      },
      {
        path: 'purchase-orders',
        name: 'PurchaseOrders',
        component: () => import(/* webpackChunkName: "PurchaseOrders" */ '@/components/stock/PurchaseOrders.vue'),
      },
      {
        path: 'purchase-orders-approval/:section/:unit?',
        name: 'PurchaseOrdersApproval',
        component: () => import(/* webpackChunkName: "PurchaseOrdersApproval" */ '@/components/stock/PurchaseOrdersApproval.vue'),
      },
      {
        path: 'purchase-orders-confirm/:section/:unit?',
        name: 'PurchaseOrdersConfirm',
        component: () => import(/* webpackChunkName: "PurchaseOrdersConfirm" */ '@/components/stock/PurchaseOrdersConfirm.vue'),
      },
      {
        path: 'inward-acquire/:section/:unit?',
        name: 'StockInwardAcquire',
        component: () => import(/* webpackChunkName: "StockInwardAcquire" */ '@/components/stock/PurchaseOrdersAcquire.vue'),
      },
    ]
  },

  {
    path: '/polls',
    name: 'PollsList',
    component: () => import(/* webpackChunkName: "PollsList" */ '@/components/polling/PollsList.vue'),
    // meta: {permission: 'poll'},
  },
  {
    path: '/polls/:uuid',
    name: 'PollView',
    component: () => import(/* webpackChunkName: "PollView" */ '@/components/polling/PollView.vue'),
  },

  {
    path: '/rtl-registration',
    name: 'RTLRegistration',
    component: () => import(/* webpackChunkName: "RTLRegistration" */ '@/components/rtl_registration/Registrations.vue'),
  },
  {
    path: '/rtl-registration/overall-approval',
    name: 'RTLRegistrationOverallApproval',
    component: () => import(/* webpackChunkName: "RTLRegistrationOverallApproval" */ '@/components/rtl_registration/RegistrationApprovalList.vue'),
  },
  {
    path: '/rtl-registration/hr-approval',
    name: 'RTLRegistrationHRApproval',
    component: () => import(/* webpackChunkName: "RTLRegistrationHRApproval" */ '@/components/rtl_registration/RegistrationApprovalList.vue'),
    meta: {
      permission: 'hrms'
    }
  },

  {
    path: '/att-logs',
    name: 'AttLogs',
    component: () => import(/* webpackChunkName: "att-logs" */ '@/components/attendance/AttLogs.vue'),
    // meta: { permission: 'hrms' },
  },

  {
    path: '/att-log-sync',
    name: 'AttLogSync',
    component: () => import(/* webpackChunkName: "att-log-sync" */ '@/components/att-log-sync/AttLogSync.vue'),
    meta: { permission: 'hrms' },
  },

  {
    path: '/system-cron-jobs',
    name: 'SystemCronJobs',
    component: () => import(/* webpackChunkName: "system-cron-jobs" */ '@/components/system/SystemCronJobs.vue'),
    meta: { permission: 'hrms' },
  },

  // staff training
  {
    path: '/my-trainings',
    name: 'MyTrainings',
    component: () => import(/* webpackChunkName: "staff-training" */ '@/components/staff-training/MyTrainings.vue'),
  },
  {
    path: '/staff-training',
    name: 'StaffTrainingList',
    component: () => import(/* webpackChunkName: "staff-training" */ '@/components/staff-training/TrainingList.vue'),
    meta: { permission: 'hrms' },
  },
  {
    path: '/staff-training/:id',
    name: 'StaffTrainingDetail',
    component: () => import(/* webpackChunkName: "staff-training" */ '@/components/staff-training/TrainingDetail.vue'),
    meta: { permission: 'hrms' },
  },

  // monthly schedule: shared calendar (WFH, leave plans, …), supervisor approval, HR entry types
  {
    path: '/calendar',
    name: 'MonthlyCalendar',
    component: () => import(/* webpackChunkName: "monthly-schedule" */ '@/components/monthly-schedule/MonthlyCalendar.vue'),
  },
  // HR Staff menu: the calendar of all staff, and HR's approved WFH
  {
    path: '/hrms/calendar',
    name: 'HrCalendar',
    component: () => import(/* webpackChunkName: "monthly-schedule" */ '@/components/monthly-schedule/MonthlyCalendar.vue'),
    props: { hr: true },
    meta: { permission: 'hrms' },
  },

  // ------------------------ Add routes here (or somewhere above) --------------------------

  {
    path: '/role-users',
    name: 'RoleUsers',
    component: () => import(/* webpackChunkName: "acl" */ '@/components/acl/RoleUsers.vue'),
    meta: {
      permission: 'all_permissions'
    }
  },

  {
    path: '/403',
    name: 'E403',
    component: ErrorPage,
    meta: {
      errorCode: '403',
      errorMessage: 'You are not allowed here',
    }
  },

  {
    path: '*',
    name: 'E404',
    component: ErrorPage,
    meta: {
      errorCode: '404',
      errorMessage: 'There\'s nothing here. Are you lost?',
    }
  },

  {
    path: '/leave-planner',
    name: 'LeavePlanner',
    component: () => import(/* webpackChunkName: "leave-planner" */ '@/components/leave-planner/LeavePlanner.vue'),
    meta: { permission: 'all_permissions' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach(async (to, from, next) => {
  let resolved = router.resolve(to.path)
  // console.log(resolved);
  if (resolved.route.name != 'E404' && resolved.route.name != 'E403' && to.meta && to.meta.permission) {
    let can = await store.dispatch("getUserCan");

    // console.log(to);
    // console.log(can)

    // if can array is empty, or required permission not present
    // meta.permission may be a single slug or an array of slugs (any one passes)
    const required = Array.isArray(to.meta.permission) ? to.meta.permission : [to.meta.permission]
    if (Object.values(can).length === 0 || (!can['all_permissions'] && !required.some(p => can[p] != null))) {
      return next('/403')
    }
  }
  return next()
})

export default router
